import { tracked } from '@glimmer/tracking';
import DataViewController from 'cpc-license-manager/utils/data-view-controller';
import DataView from 'cpc-license-manager/constants/data-view';

export default class LicensesController extends DataViewController {
  @tracked sortByField = 'createdAt';
  @tracked sortDirection = DataView.SORT_DESC;
  @tracked totalRecords = 0;

  get sortableData() {
    return this.filteredLicenses;
  }

  get filteredLicenses() {
    return this.model.filter((mod) => !mod.isNew || !mod.isDeleted);
  }
}
